import clsx from 'clsx';
import { ChevronRight } from 'mdi-material-ui';
import { Link } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

import home from '@/assets/menu/icon_menu_default_home.svg';

export const Breadcrumbs = () => {
	const routes = [
		//Patient Assignment
		{ path: '/patient-assignment/', breadcrumb: 'Patient Assignment' },
		{ path: '/patient-assignment/identify-patients', breadcrumb: 'Identify Patients' },

		//Patient Contact
		{ path: '/patient-contact/', breadcrumb: 'Patient Contact' },
		{ path: '/patient-contact/add-template', breadcrumb: 'Add Template' },
		{ path: '/patient-contact/send-letter', breadcrumb: 'Send Letter' },
		{ path: '/patient-contact/send-letter/preview', breadcrumb: 'Preview' },
		{
			path: '/patient-contact/mailings/:mailingListId',
			breadcrumb: 'Mailing Patient List',
		},
		{ path: '/patient-contact/create-mailing-list', breadcrumb: 'Create Mailing List' },
		{
			path: '/patient-contact/mailing-list-patients/:mailingListId',
			breadcrumb: 'Patient List',
		},
		{
			path: '/patient-contact/mailing-list-patients/:mailingListId/edit',
			breadcrumb: 'Edit Mailing List',
		},

		// Patient Engagement
		{ path: '/patient-engagement/', breadcrumb: 'Patient Engagement' },
		{ path: '/patient-engagement/:patient_identifier', breadcrumb: 'Patient Details' },
		{
			path: '/patient-engagement/:patient_identifier/edit',
			breadcrumb: 'Edit Patient Details',
		},

		// Patient Screening
		{ path: '/patient-screening/', breadcrumb: 'Patient Screening' },
		{
			path: '/patient-screening/:patient_identifier/complete-screening',
			breadcrumb: 'Completing manual screening process',
		},
		{
			path: '/patient-screening/:patient_identifier/survey-assignment/:assignment_identifier',
			breadcrumb: 'Survey',
		},

		// Trial Sites
		{
			path: '/trial-sites/',
			breadcrumb: 'Trial Sites',
		},
		{
			path: '/trial-sites/:patient_identifier',
			breadcrumb: 'Patient Details',
		},
		{
			path: '/trial-sites/:patient_identifier/complete-screening',
			breadcrumb: 'Complete Screening',
		},
		{
			path: '/trial-sites/:patient_identifier/survey-assignment/:assignment_identifier',
			breadcrumb: 'Survey',
		},

		// Reporting
		{
			path: '/reporting/',
			breadcrumb: 'Reporting',
		},
		{
			path: '/reporting/study-progress',
			breadcrumb: 'Study progress',
		},
		{
			path: '/reporting/study-patient-status',
			breadcrumb: 'Patient status',
		},
		{
			path: '/reporting/ab-testing-metrics',
			breadcrumb: 'A/B Testing Metrics',
		},
		{
			path: '/reporting/dashboard',
			breadcrumb: 'Dashboard',
		},
		{
			path: '/reporting/cancelled-patients',
			breadcrumb: 'Opted Out and Deceased Patients',
		},

		// Healthcare Institution
		{ path: '/health-care-institution/', breadcrumb: 'Health care institution list' },
		{ path: '/health-care-institution/:institution_id', breadcrumb: 'HCI details' },
		{ path: '/health-care-institution/add', breadcrumb: 'Add new HCI' },
		{ path: '/health-care-institution/:institution_id/edit', breadcrumb: 'Edit HCI' },
		{ path: '/health-care-institution/:institution_id/project/add', breadcrumb: 'Add project' },
		{
			path: '/health-care-institution/:institution_id/project/:project_id/edit',
			breadcrumb: 'Manage project participation',
		},

		// Clinical Admin
		{ path: '/clinical-admin/', breadcrumb: 'Clinical Admin' },
		{ path: '/clinical-admin/:patient_identifier', breadcrumb: 'Patient Details' },
		{
			path: '/clinical-admin/:patient_identifier/complete-screening',
			breadcrumb: 'Completing manual screening process',
		},
		{
			path: '/clinical-admin/:patient_identifier/survey-assignment/:assignment_identifier',
			breadcrumb: 'Survey',
		},

		// Patient Lists
		{ path: '/patient-lists/', breadcrumb: 'Patient Lists' },
		{ path: '/patient-lists/patients/:patient_identifier', breadcrumb: 'Patient Details' },
		{
			path: '/patient-lists/patients/:patient_identifier/edit',
			breadcrumb: 'Edit Patient Details',
		},
		{ path: '/patient-lists/lists/create-list', breadcrumb: 'Create list' },
		{ path: '/patient-lists/lists/:list_identifier', breadcrumb: 'List Details' },
		{ path: '/patient-lists/lists/:list_identifier/send-survey', breadcrumb: 'Send survey' },
		{
			path: '/patient-lists/lists/:list_identifier/send-data-sharing-link',
			breadcrumb: 'Send Data Sharing Link',
		},
		{
			path: '/patient-lists/lists/:list_identifier/patient-assignment',
			breadcrumb: 'Patient assignment',
		},

		// Patient Engagement Lifecycle
		{
			path: '/patient-engagement-lifecycle',
			breadcrumb: 'Patient Engagement Lifecycle',
		},
		{
			path: '/patient-engagement-lifecycle/patient-assignment',
			breadcrumb: 'Patient Assignment',
		},
		{ path: '/patient-engagement-lifecycle/patient-progress', breadcrumb: 'Patient Progress' },
		{
			path: '/patient-engagement-lifecycle/patient-lists',
			breadcrumb: 'Patient Lists',
		},
		{
			path: '/patient-engagement-lifecycle/trial-sites',
			breadcrumb: 'Trial Sites',
		},
		{
			path: '/patient-engagement-lifecycle/reporting',
			breadcrumb: 'Reporting',
		},

		// Patient Registration
		{
			path: '/incomplete-registrations',
			breadcrumb: 'Incomplete registrations',
		},

		// Trial Site Management
		{ path: '/trial-site-management', breadcrumb: 'Trial Site Management' },

		// Miscellaneous
		{ path: '/', breadcrumb: 'Home' },
		{ path: '/patient-approval/', breadcrumb: 'Patient Approval' },
		{ path: '/find/', breadcrumb: 'Find' },
	];

	const breadcrumbs = useBreadcrumbs(routes, { disableDefaults: true });

	return (
		<div className='flex flex-row mb-4 mx-8' data-test-id='breadcrumbs'>
			<img
				className='w-4 mr-2'
				alt={'breadcrumb_home'}
				title={'breadcrumb_home'}
				src={home}
			/>
			{breadcrumbs.map(({ match, breadcrumb }, index: number) => (
				<Link
					className={clsx(
						'flex flex-row items-center text-body-sm',
						index === breadcrumbs.length - 1
							? 'text-primaryTextDark font-medium'
							: 'text-tertiaryTextDark font-normal'
					)}
					key={match.pathname}
					to={match.pathname}
				>
					{breadcrumb}
					{index === breadcrumbs.length - 1 ? null : (
						<ChevronRight className={clsx('mx-1 md:mx-1 text-tertiaryTextDark')} />
					)}
				</Link>
			))}
		</div>
	);
};
